export default "<users-list (reloadUsers)=\"reloadUsers($event)\"\n            [initialUsersSet]=\"initialUsers\">\n</users-list>\n";